import { handleActions } from 'redux-actions'
import {
  CONSULTAR_PLACA,
  CONSULTAR_PLACA_HAS_ERRORED,
  CONSULTAR_PLACA_IS_LOADING,
  CONSULTAR_CEDULA_HAS_ERRORED,
  CONSULTAR_CEDULA_ASEGURADO_HAS_ERRORED,
  CONSULTAR_CEDULA_IS_LOADING,
  SET_DATOS_PERSONA,
  LIMPIAR_DATOS_COTIZACION,
  LISTAR_ACCESORIOS_HAS_ERRROR,
  LISTAR_ACCESORIOS_IS_LOADING,
  LISTAR_COLORES_HAS_ERRROR,
  LISTAR_COLORES_IS_LOADING,
  SET_COLORES,
  LISTAR_TERRITORIOS_IS_LOADING,
  LISTAR_TERRITORIOS_HAS_ERRROR,
  SET_TERRITORIOS,
  SET_TERRITORIO_DEFAULT,
  SET_ACCESORIOS,
  LIMPIAR_DATOS_COTIZACION2,
  LISTAR_MODELOS_IS_LOADING,
  LISTAR_MODELOS_HAS_ERRROR,
  SET_MODELOS,
  LIMPIAR_CATALOGOS,
  SET_DATOS_PAGADOR,
  OBTENER_DATOS_CLIENTE_IS_LOADING,
  OBTENER_DATOS_CLIENTE_HAS_ERRORED,
  LISTAR_ESTADOS_CIVILES_HAS_ERROR,
  LISTAR_ESTADOS_CIVILES_IS_LOADING,
  SET_ESTADOS_CIVILES,
  LISTAR_GENEROS_IS_LOADING,
  LISTAR_GENEROS_HAS_ERROR,
  SET_GENEROS,
  LISTAR_PROVINCIAS_IS_LOADING,
  LISTAR_PROVINCIAS_HAS_ERROR,
  SET_CIUDADES,
  SET_CIUDADES2,
  SET_PROVINCIAS,
  SET_PROVINCIAS2,
  LISTAR_CIUDADES_IS_LOADING,
  LISTAR_CIUDADES_HAS_ERROR,
  GUARDAR_DATOS_HAS_ERROR,
  GUARDAR_DATOS_IS_LOADING,
  SET_DATOS_PAGO,
  SET_DATOS_DESCARGA,
  GENERAR_COTIZACION_HAS_ERROR,
  GENERAR_COTIZACION_IS_LOADING,
  DESCARGA_OK,
  ENVIO_OK,
  LIMPIAR_DATOS_DESCARGA,
  LIMPIAR_DATOS_ENVIO,
  SET_DATOS_FACTURACION,
  CORREO_ENVIAR,
  ENVIAR_COTIZACION_HAS_ERROR,
  ENVIAR_COTIZACION_IS_LOADING,
  CONSULTAR_COBERTURAS_HAS_ERRORED,
  CONSULTAR_COBERTURAS_IS_LOADING,
  SET_COBERTURAS,
  TIENE_POLIZA_PLACA,
  MENSAJE_ERROR_POLIZA_PLACA,
  AMPAROS_ADICIONALES_HAS_ERRORED,
  AMPAROS_ADICIONALES_IS_LOADING,
  SET_AMPAROS_ADICIONALES,
  GUARDAR_LEAD_HAS_ERRORED,
  GUARDAR_LEAD_IS_LOADING,
  OBTENER_AYUDA_HAS_ERRORED,
  OBTENER_AYUDA_IS_LOADING,
  LIMPIAR_AYUDA,
  SET_AYUDA,
  LIMPIAR_PORCENTAJE_EXTRAS,
  PORCENTAJE_EXTRAS_LOADING,
  PORCENTAJE_EXTRAS_HAS_ERRORED,
  SET_PORCENTAJE_EXTRAS,
  OBTENER_MSG_HAS_ERRORED,
  OBTENER_MSG_IS_LOADING,
  SET_MSG,
  OBTENER_VALIDAR_MODELO_HAS_ERRORED,
  OBTENER_VALIDAR_MODELO_IS_LOADING,
  SET_VALIDAR_MODELO,
  VALIDAR_PAGO_PENDIENTE_HAS_ERRORED,
  VALIDAR_PAGO_PENDIENTE_IS_LOADING,
  OBTENER_URL_PAGO_HAS_ERRORED,
  OBTENER_URL_PAGO_IS_LOADING,
  LIMPIAR_URL_PAGO,
  LIMPIAR_DASHBOARD,
  DASHBOARD_LOADING,
  DASHBOARD_ERRORED,
  SET_DASHBOARD,
  deduciblesRolesisLoading,
  deduciblesRoleshasError,
  deduciblesRoles,
  SET_PERSONERIA_TIPO_IDENTI,
  CONSULTAR_IDENTIFICACION_AP_HAS_ERRORED,
  CONSULTAR_IDENTIFICACION_AP_IS_LOADING,
  SET_CONSULTAR_IDENTIFICACION_AP,
  calculoCotizacionAPIsLoading,
  calculoCotizacionAPhasError,
  setCalculoCotizacionAP,
  OBTENER_DATOS_HAS_ERRORED,
  OBTENER_FORMAS_PAGO_HAS_ERRORED,
  OBTENER_FORMAS_PAGO_IS_LOADING,
  SET_OBTENER_FORMAS_PAGO,
  OBTENER_DATOS_DEBITO_HAS_ERRORED,
  OBTENER_DATOS_DEBITO_IS_LOADING,
  SET_OBTENER_DATOS_DEBITO,
  OBTENER_CONDUCTOS_IS_LOADING,
  OBTENER_CONDUCTOS_HAS_ERRORED,
  SET_OBTENER_CONDUCTOS,
  GUARDAR_CONDUCTO_HAS_ERRORED,
  GUARDAR_CONDUCTO_IS_LOADING,
  SET_GUARDAR_CONDUCTO,
  GUARDAR_FORMA_PAGO_HAS_ERRORED,
  GUARDAR_FORMA_PAGO_IS_LOADING,
  SET_GUARDAR_FORMA_PAGO,
  setProvinciasHogar,
  listarProvinciasHogarError,
  listarProvinciasHogarloading,
  setRelatividadesHogar,
  listarRelatividadesHogarError,
  listarRelatividadesHogarloading,
  recuperarDatosFacturacionIsLoading,
  recuperarDatosFacturacionhasError,
  setRecuperarDatosFacturacion,
  guardarDatosFacturacionIsLoading,
  guardarDatosFacturacionhasError,
  setDatosFacturacionC,
  setLimitesChasis,
  setLimitesAmparo,
  setLimitesAvaluo,
  setLimitesMotor,
  limitesError,
  setListadoCotizadoresPermisos,
  setMostrarMsgErrorPermisos,
  setMsgError,
  setIsLoadingPermisos,
  setDatosAdicionales,
  setDataTerritoriosComparador,
  SET_DATOS_PERSONA_ASEGURADO,
  SET_PARENTESCOS
} from "../actions/aCotizacion";
const dataCotizacion = {
  consultarPlacaIsLoading: false,
  consultarPlacaHasError: false,
  tienePolizaPlaca: false,
  mensajeErrorPolizaPlaca: '',
  consultarCedulaIsLoading: false,
  consultarCedulaHasError: false,
  consultarCedulaAseguradoHasError: false,
  datosPersona: {},
  datosPlaca: {},
  datosPagador: {},
  datosFacturacion: {},
  obtenerDatosClienteHasError: false,
  obtenerDatosClienteIsLoading: false,
  generarCotizacionIsLoading: false,
  generarCotizacionHasError: false,
  enviarCotizacionIsLoading: false,
  enviarCotizacionHasError: false,
  datosDescarga: {},
  descargaOk: false,
  envioOK: false,
  porcentajeExtras: 0,
  porcentajeExtrasIsLoading: false,
  porcentajeExtrasHasErrored: false,
  textoMsg: "",
  loadingMsg: false,
  erroMsg: false,
  validarModeloLoading: false,
  validarModeloError: false,
  modeloRestringido: false
};
export const datosCotizacion = (state = dataCotizacion, action) => {
  switch (action.type) {
    case CONSULTAR_PLACA_IS_LOADING:
      return {
        ...state,
        consultarPlacaIsLoading: true,
        consultarPlacaHasError: false
      };
    case CONSULTAR_PLACA_HAS_ERRORED:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        consultarPlacaHasError: true
      };
    case TIENE_POLIZA_PLACA:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        tienePolizaPlaca: true,
      };

    case MENSAJE_ERROR_POLIZA_PLACA:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        mensajeErrorPolizaPlaca: action.payload,
      };
    case CONSULTAR_PLACA:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        consultarPlacaHasError: false,
        datosPlaca: action.payload
      };
    case SET_DATOS_PERSONA:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        consultarPlacaHasError: false,
        consultarCedulaIsLoading: false,
        consultarCedulaHasError: false,
        consultarCedulaAseguradoHasError: false,
        datosPersona: action.payload
      };
    case SET_DATOS_PERSONA_ASEGURADO:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        consultarPlacaHasError: false,
        consultarCedulaIsLoading: false,
        consultarCedulaHasError: false,
        consultarCedulaAseguradoHasError: false,
        datosPersonaAsegurado: action.payload
      };
    case CONSULTAR_CEDULA_IS_LOADING:
      return {
        ...state,
        consultarCedulaIsLoading: true,
        consultarCedulaHasError: false,
        consultarCedulaAseguradoHasError: false,
      };
    case CONSULTAR_CEDULA_HAS_ERRORED:
      return {
        ...state,
        consultarCedulaIsLoading: false,
        consultarCedulaHasError: true
      };

      case CONSULTAR_CEDULA_ASEGURADO_HAS_ERRORED:
        return {
          ...state,
          consultarCedulaIsLoading: false,
          consultarCedulaAseguradoHasError: true
        };


    case SET_DATOS_PAGADOR:
      return {
        ...state,
        obtenerDatosClienteIsLoading: false,
        obtenerDatosClienteHasError: false,
        datosPagador: action.payload,

      };
    case SET_DATOS_FACTURACION:
      return {
        ...state,
        obtenerDatosClienteIsLoading: false,
        obtenerDatosClienteHasError: false,
        datosFacturacion: action.payload
      };
    case OBTENER_DATOS_CLIENTE_IS_LOADING:
      return {
        ...state,
        obtenerDatosClienteIsLoading: true,
        obtenerDatosClienteHasError: false,
      };
    case OBTENER_DATOS_CLIENTE_HAS_ERRORED:
      return {
        ...state,
        obtenerDatosClienteIsLoading: false,
        obtenerDatosClienteHasError: true,
      };




    case SET_DATOS_DESCARGA:
      return {
        ...state,
        generarCotizacionIsLoading: false,
        generarCotizacionHasError: false,
        enviarCotizacionIsLoading: false,
        enviarCotizacionHasError: false,
        datosDescarga: action.payload

      };
    case GENERAR_COTIZACION_HAS_ERROR:
      return {
        ...state,
        generarCotizacionIsLoading: false,
        generarCotizacionHasError: true,
      };
    case GENERAR_COTIZACION_IS_LOADING:
      return {
        ...state,
        generarCotizacionIsLoading: true,
        generarCotizacionHasError: false,
      };
    case ENVIAR_COTIZACION_HAS_ERROR:
      return {
        ...state,
        enviarCotizacionIsLoading: false,
        enviarCotizacionHasError: true,
      };
    case ENVIAR_COTIZACION_IS_LOADING:
      return {
        ...state,
        enviarCotizacionIsLoading: true,
        enviarCotizacionHasError: false,
      };

    case DESCARGA_OK:
      return {
        ...state,
        descargaOk: action.payload,

      };
    case ENVIO_OK:
      return {
        ...state,
        envioOK: action.payload,

      };
    case CORREO_ENVIAR:
      return {
        ...state,
        correo: action.payload,

      };

    case LIMPIAR_DATOS_DESCARGA:
      return {
        ...state,
        generarCotizacionIsLoading: false,
        generarCotizacionHasError: false,
        datosDescarga: {},
        descargaOk: false
      };

    case LIMPIAR_DATOS_ENVIO:
      return {
        ...state,
        enviarCotizacionIsLoading: false,
        enviarCotizacionHasError: false,
        datosDescarga: {},
        envioOK: false
      };

    case LIMPIAR_DATOS_COTIZACION:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        consultarPlacaHasError: false,
        consultarCedulaIsLoading: false,
        consultarCedulaHasError: false,
        consultarCedulaAseguradoHasError: false,
        datosPersona: {},
        datosPlaca: {},
        tienePolizaPlaca: false,
        mensajeErrorPolizaPlaca: ''
      };

    case LIMPIAR_DATOS_COTIZACION2:
      return {
        ...state,
        consultarPlacaIsLoading: false,
        consultarPlacaHasError: false,
        consultarCedulaIsLoading: false,
        consultarCedulaHasError: false,
        consultarCedulaAseguradoHasError: false,
        tienePolizaPlaca: false,
        mensajeErrorPolizaPlaca: ''
      };

    case PORCENTAJE_EXTRAS_LOADING:
      return {
        ...state,
        porcentajeExtrasIsLoading: true,
        porcentajeExtrasHasErrored: false
      };

    case PORCENTAJE_EXTRAS_HAS_ERRORED:
      return {
        ...state,
        porcentajeExtrasIsLoading: false,
        porcentajeExtrasHasErrored: true,
        porcentajeExtras: 0
      };

    case SET_PORCENTAJE_EXTRAS:
      return {
        ...state,
        porcentajeExtras: action.payload,
      };

    case OBTENER_MSG_IS_LOADING:
      return {
        ...state,
        loadingMsg: true,
        erroMsg: false,
      };
    case OBTENER_MSG_HAS_ERRORED:
      return {
        ...state,
        loadingMsg: false,
        erroMsg: true,
      };
    case SET_MSG:
      return {
        ...state,
        textoMsg: action.payload,
      };
    case OBTENER_VALIDAR_MODELO_IS_LOADING:
      return {
        ...state,
        validarModeloLoading: true,
        validarModeloError: false,
      }

    case OBTENER_VALIDAR_MODELO_HAS_ERRORED:
      return {
        ...state,
        validarModeloLoading: false,
        validarModeloError: true,
      }

    case SET_VALIDAR_MODELO:
      return {
        ...state,
        modeloRestringido: action.payload,
      };

    default:
      return state;
  }
};



const dataPlaca = {
  listarAccesoriosIsLoading: false,
  listarAccesoriosHasError: false,
  listarTerritoriosIsLoading: false,
  listarTerritoriosHasError: false,
  colores: {},
  accesorios: {},
  territorios: {},
  listarModelosIsLoading: false,
  listarModelosHasError: false,
  modelos: [],
  listarEstadosCivilesHasError: false,
  listarEstadosCivilesIsLoading: false,
  estadosCiviles: [],
  parentescos: [],
  listarGenerosHasError: false,
  listarGenerosIsLoading: false,
  generos: [],
  listarProvinciasHasError: false,
  listarProvinciasIsLoading: false,
  provincias: [],
  listarCiudadesHasError: false,
  listarCiudadesIsLoading: false,
  ciudades: [],
  consultarCobertruasHasError: false,
  consultarCoberturasIsLoading: false,
  coberturas: {},
  territorioDefault: 0,
  amparosAdicionales: {},
  personeria: { isLoading: false, tiposPersoneria: [], tiposIdentificacion: [] },
  provinciasSelect: [],
  ciudadesSelect: [],
  provinciasHogar: []
};
export const catalogosCotizacion = (state = dataPlaca, action) => {
  switch (action.type) {
    case LISTAR_COLORES_IS_LOADING:
      return {
        ...state,
        listarColoresIsLoading: true,
        listarColoresHasError: false
      };
    case LISTAR_COLORES_HAS_ERRROR:
      return {
        ...state,
        listarColoresIsLoading: false,
        listarColoresHasError: true
      };
    case SET_COLORES:
      return {
        ...state,
        listarColoresIsLoading: false,
        listarColoresHasError: false,
        colores: action.payload
      };
    case LISTAR_ACCESORIOS_IS_LOADING:
      return {
        ...state,
        listarAccesoriosIsLoading: true,
        listarAccesoriosHasError: false
      };
    case LISTAR_ACCESORIOS_HAS_ERRROR:
      return {
        ...state,
        listarAccesoriosIsLoading: false,
        listarAccesoriosHasError: true
      };
    case SET_ACCESORIOS:
      return {
        ...state,
        listarAccesoriosIsLoading: false,
        listarAccesoriosHasError: false,
        accesorios: action.payload
      };
    case LISTAR_TERRITORIOS_IS_LOADING:
      return {
        ...state,
        listarTerritoriosHasError: false,
        listarTerritoriosIsLoading: true
      };
    case LISTAR_TERRITORIOS_HAS_ERRROR:
      return {
        ...state,
        listarTerritoriosHasError: true,
        listarTerritoriosIsLoading: false
      };
    case SET_TERRITORIOS:
      return {
        ...state,
        listarTerritoriosIsLoading: false,
        listarTerritoriosHasError: false,
        territorios: action.payload
      };
    case SET_TERRITORIO_DEFAULT:
      return {
        ...state,
        listarTerritoriosIsLoading: false,
        listarTerritoriosHasError: false,
        territorioDefault: action.payload
      };

    case LISTAR_MODELOS_IS_LOADING:
      return {
        ...state,
        listarModelosHasError: false,
        listarModelosIsLoading: true
      };
    case LISTAR_MODELOS_HAS_ERRROR:
      return {
        ...state,
        listarModelosHasError: true,
        listarModelosIsLoading: false
      };
    case SET_MODELOS:
      return {
        ...state,
        listarModelosIsLoading: false,
        listarModelosHasError: false,
        modelos: action.payload
      };

    case LISTAR_ESTADOS_CIVILES_IS_LOADING:
      return {
        ...state,
        listarEstadosCivilesHasError: false,
        listarEstadosCivilesIsLoading: true
      };
    case LISTAR_ESTADOS_CIVILES_HAS_ERROR:
      return {
        ...state,
        listarEstadosCivilesHasError: true,
        listarEstadosCivilesIsLoading: false
      };
    case SET_ESTADOS_CIVILES:
      return {
        ...state,
        listarEstadosCivilesHasError: false,
        listarEstadosCivilesIsLoading: false,
        estadosCiviles: action.payload
      };
    case SET_PARENTESCOS:
      return {
        ...state,
        parentescos: action.payload
      };



    case LISTAR_GENEROS_IS_LOADING:
      return {
        ...state,
        listarGenerosHasError: false,
        listarGenerosIsLoading: true
      };
    case LISTAR_GENEROS_HAS_ERROR:
      return {
        ...state,
        listarGenerosHasError: true,
        listarGenerosIsLoading: false
      };
    case SET_GENEROS:
      return {
        ...state,
        listarGenerosHasError: false,
        listarGenerosIsLoading: false,
        generos: action.payload
      };

    case AMPAROS_ADICIONALES_IS_LOADING:
      return {
        ...state,
        amparosAdicionalesHasError: false,
        amparosAdicionalesisLoading: true
      };

    case AMPAROS_ADICIONALES_HAS_ERRORED:
      return {
        ...state,
        amparosAdicionalesHasError: true,
        amparosAdicionalesisLoading: false
      };

    case SET_AMPAROS_ADICIONALES:
      return {
        ...state,
        amparosAdicionalesHasError: false,
        amparosAdicionalesisLoading: false,
        amparosAdicionales: action.payload
      };

    case GUARDAR_LEAD_IS_LOADING:
      return {
        ...state,
        guardarLeadHasError: false,
        guardarLeadisLoading: true
      };

    case GUARDAR_LEAD_HAS_ERRORED:
      return {
        ...state,
        guardarLeadisLoading: false,
        guardarLeadHasError: true
      };

    case LISTAR_PROVINCIAS_IS_LOADING:
      return {
        ...state,
        listarProvinciasHasError: false,
        listarProvinciasIsLoading: true
      };
    case LISTAR_PROVINCIAS_HAS_ERROR:
      return {
        ...state,
        listarProvinciasHasError: true,
        listarProvinciasIsLoading: false
      };
    case SET_PROVINCIAS:
      return {
        ...state,
        listarProvinciasHasError: false,
        listarProvinciasIsLoading: false,
        provincias: action.payload
      };

    case SET_PROVINCIAS2:
      return {
        ...state,
        listarProvinciasHasError: false,
        listarProvinciasIsLoading: false,
        provinciasSelect: action.payload
      };


    case LISTAR_CIUDADES_IS_LOADING:
      return {
        ...state,
        listarCiudadesHasError: false,
        listarCiudadesIsLoading: true
      };
    case LISTAR_CIUDADES_HAS_ERROR:
      return {
        ...state,
        listarCiudadesHasError: true,
        listarCiudadesIsLoading: false
      };
    case SET_CIUDADES:
      return {
        ...state,
        listarCiudadesHasError: false,
        listarCiudadesIsLoading: false,
        ciudades: action.payload
      };

    case SET_CIUDADES2:
      return {
        ...state,
        listarCiudadesHasError: false,
        listarCiudadesIsLoading: false,
        ciudadesSelect: action.payload
      };

    case CONSULTAR_COBERTURAS_HAS_ERRORED:
      return {
        ...state,
        consultarCobertruasHasError: true,
        consultarCedulaIsLoading: false,
      };
    case CONSULTAR_COBERTURAS_IS_LOADING:
      return {
        ...state,
        consultarCobertruasHasError: false,
        consultarCedulaIsLoading: true,
      };
    case SET_COBERTURAS:
      return {
        ...state,
        consultarCobertruasHasError: false,
        consultarCedulaIsLoading: false,
        coberturas: action.payload
      };
    case SET_PERSONERIA_TIPO_IDENTI:
      return {
        ...state,
        consultarCobertruasHasError: false,
        consultarCedulaIsLoading: false,
        personeria: action.payload
      };

    case LIMPIAR_CATALOGOS:
      return {
        ...state,
        listarModelosIsLoading: false,
        listarModelosHasError: false,
        modelos: []
      };
    default:
      return state;
  }
};




const data = {

  guardarDatosHasError: false,
  guardarDtosIsLoading: false,
  datosPagar: []
};
export const datosPago = (state = data, action) => {
  switch (action.type) {

    case GUARDAR_DATOS_IS_LOADING:
      return {
        ...state,
        guardarDatosHasError: false,
        guardarDtosIsLoading: true,
      };
    case GUARDAR_DATOS_HAS_ERROR:
      return {
        ...state,
        guardarDatosHasError: true,
        guardarDtosIsLoading: false,
      };
    case SET_DATOS_PAGO:
      return {
        ...state,
        guardarDatosHasError: false,
        guardarDtosIsLoading: false,
        datosPagar: action.payload
      };



    default:
      return state;
  }
};

const dataAyuda = {

  obtenerAyudaError: false,
  obtenerAyudaIsLoading: false,
  datosAyuda: {}
};

export const datosAyuda = (state = dataAyuda, action) => {
  switch (action.type) {

    case OBTENER_AYUDA_IS_LOADING:
      return {
        ...state,
        obtenerAyudaError: false,
        obtenerAyudaIsLoading: true,
      };
    case OBTENER_AYUDA_HAS_ERRORED:
      return {
        ...state,
        obtenerAyudaError: true,
        obtenerAyudaIsLoading: false,
      };
    case SET_AYUDA:
      return {
        ...state,
        obtenerAyudaError: false,
        obtenerAyudaIsLoading: false,
        datosAyuda: action.payload
      };
    case LIMPIAR_AYUDA:
      return {
        ...state,
        obtenerAyudaError: false,
        obtenerAyudaIsLoading: false,
        datosAyuda: {}
      };
    default:
      return state;
  }
};


const dataValidarPagoPendiente = {

  validarPagoPendienteHasError: false,
  validarPagoPendienteIsLoading: false,
};
export const datosValidarPagoPendiente = (state = dataValidarPagoPendiente, action) => {
  switch (action.type) {

    case VALIDAR_PAGO_PENDIENTE_IS_LOADING:
      return {
        ...state,
        validarPagoPendienteHasError: false,
        validarPagoPendienteIsLoading: true,
      };
    case VALIDAR_PAGO_PENDIENTE_HAS_ERRORED:
      return {
        ...state,
        validarPagoPendienteHasError: true,
        validarPagoPendienteIsLoading: false,
      };


    default:
      return state;
  }
};

const dataObtenerUrlPlaceToPay = {

  obtenerUrlPagoError: false,
  obtenerUrlPagoIsLoading: false,
  msgUrlPago: false
};
export const datosObtenerUrlPlaceToPay = (state = dataObtenerUrlPlaceToPay, action) => {
  switch (action.type) {

    case OBTENER_URL_PAGO_IS_LOADING:
      return {
        ...state,
        obtenerUrlPagoError: false,
        obtenerUrlPagoIsLoading: true,
        msgUrlPago: false
      };
    case OBTENER_URL_PAGO_HAS_ERRORED:
      return {
        ...state,
        obtenerUrlPagoError: true,
        obtenerUrlPagoIsLoading: false,
        msgUrlPago: true
      };
    case LIMPIAR_URL_PAGO:
      return {
        ...state,
        obtenerUrlPagoError: false,
        obtenerUrlPagoIsLoading: false,
      };
    default:
      return state;
  }
};

const dataDashboard = {

  dashboardLoading: false,
  dashboardErrored: false,
  datosDashboard: {}
};

export const datosDashboard = (state = dataDashboard, action) => {
  switch (action.type) {

    case DASHBOARD_LOADING:
      return {
        ...state,
        dashboardErrored: false,
        dashboardLoading: true,
      };
    case DASHBOARD_ERRORED:
      return {
        ...state,
        dashboardErrored: true,
        dashboardLoading: false,
      };
    case LIMPIAR_URL_PAGO:
      return {
        ...state,
        dashboardErrored: false,
        dashboardLoading: false,
      };
    case SET_DASHBOARD:
      return {
        ...state,
        dashboardErrored: false,
        dashboardLoading: false,
        datosDashboard: action.payload
      };

    default:
      return state;
  }
};



export const deduciblesRolesDatos = handleActions(
  {
    [deduciblesRolesisLoading]: (state) => ({ ...state, deduciblesRolesisLoading: true, deduciblesRoleshasError: false, }),
    [deduciblesRoleshasError]: (state) => ({ ...state, deduciblesRoleshasError: true, deduciblesRolesisLoading: false }),
    [deduciblesRoles]: (state, action) => ({ ...state, deduciblesRoles: action.payload, deduciblesRoleshasError: false, deduciblesRolesisLoading: false })
  },
  {
    deduciblesRolesisLoading: false,
    deduciblesRoleshasError: false,
    deduciblesRoles: [],
  }
);


//Consultar Identificacion - Cotizacion Accidentes Personales
const dataIdentificacionAP = {

  consultarIdentificacionAPhasError: false,
  consultarIdentificacionAPIsLoading: false,
  IdentificacionAP: {}
};
export const datosIdentificacionAP = (state = dataIdentificacionAP, action) => {
  switch (action.type) {

    case CONSULTAR_IDENTIFICACION_AP_IS_LOADING:
      return {
        ...state,
        consultarIdentificacionAPhasError: false,
        consultarIdentificacionAPIsLoading: true,
      };
    case CONSULTAR_IDENTIFICACION_AP_HAS_ERRORED:
      return {
        ...state,
        consultarIdentificacionAPhasError: true,
        consultarIdentificacionAPIsLoading: false,
      };
    case SET_CONSULTAR_IDENTIFICACION_AP:
      return {
        ...state,
        consultarIdentificacionAPhasError: false,
        consultarIdentificacionAPIsLoading: false,
        IdentificacionAP: action.payload
      };
    default:
      return state;
  }
};


//Realizar Calculos - Cotizacion Accidentes Personales mediate redux-actions
export const datosCalculosCotizacionAP = handleActions(
  {
    [calculoCotizacionAPIsLoading]: (state) => ({ ...state, calculoCotizacionAPIsLoading: true, calculoCotizacionAPhasError: false, }),
    [calculoCotizacionAPhasError]: (state) => ({ ...state, calculoCotizacionAPhasError: true, calculoCotizacionAPIsLoading: false }),
    [setCalculoCotizacionAP]: (state, action) => ({ ...state, CalculoCotizacionAP: action.payload, calculoCotizacionAPhasError: false, calculoCotizacionAPIsLoading: false })
  },
  {
    calculoCotizacionAPIsLoading: false,
    calculoCotizacionAPhasError: false,
    CalculoCotizacionAP: [],
  }
);

//Formas de pago adicionales------------------------------------------
const formasPago = {
  obtenerFormasPagoIsLoading: false,
  obtenerFormasPagoHasError: false,
  FormasPago: {},
};
export const datosFormasPago = (state = formasPago, action) => {
  switch (action.type) {
    case OBTENER_FORMAS_PAGO_HAS_ERRORED:
      return {
        ...state,
        obtenerFormasPagoIsLoading: false,
        obtenerFormasPagoHasError: true,
      };
    case OBTENER_FORMAS_PAGO_IS_LOADING:
      return {
        ...state,
        obtenerFormasPagoIsLoading: true,
        obtenerFormasPagoHasError: false,
      };
    case SET_OBTENER_FORMAS_PAGO:
      return {
        ...state,
        FormasPago: action.payload,
        obtenerFormasPagoIsLoading: false,
        obtenerFormasPagoHasError: false,
      };
    default:
      return state;
  }
};
const debitoAuomaticoDatos = {
  obtenerDatosDebitoAutomaticoIsLoading: false,
  obtenerDatosDebitoAutomaticoHasError: false,
  debitoAuomatico: {},
};
export const datosDebitoAutomatico = (state = debitoAuomaticoDatos, action) => {
  switch (action.type) {
    case OBTENER_DATOS_DEBITO_HAS_ERRORED:
      return {
        ...state,
        obtenerDatosDebitoAutomaticoIsLoading: false,
        obtenerDatosDebitoAutomaticoHasError: true,
      };
    case OBTENER_DATOS_DEBITO_IS_LOADING:
      return {
        ...state,
        obtenerDatosDebitoAutomaticoIsLoading: true,
        obtenerDatosDebitoAutomaticoHasError: false,
      };
    case SET_OBTENER_DATOS_DEBITO:
      return {
        ...state,
        debitoAuomatico: action.payload,
        obtenerDatosDebitoAutomaticoIsLoading: false,
        obtenerDatosDebitoAutomaticoHasError: false,
      };
    default:
      return state;
  }
};
const Conductos = {
  obtenerConductosIsLoading: false,
  obtenerConductosHasError: false,
  listaConductos: [],
};
export const datosListadoConductos = (state = Conductos, action) => {
  switch (action.type) {
    case OBTENER_CONDUCTOS_HAS_ERRORED:
      return {
        ...state,
        obtenerConductosIsLoading: false,
        obtenerConductosHasError: true,
      };
    case OBTENER_CONDUCTOS_IS_LOADING:
      return {
        ...state,
        obtenerConductosIsLoading: true,
        obtenerConductosHasError: false,
      };
    case SET_OBTENER_CONDUCTOS:
      return {
        ...state,
        listaConductos: action.payload,
        obtenerConductosIsLoading: false,
        obtenerConductosHasError: false,
      };
    default:
      return state;
  }
};
const dataConducto = {
  guardarConductoHasError: false,
  guardarConductoIsLoading: false,
  datoConducto: []
};
export const datosGuardarConducto = (state = dataConducto, action) => {
  switch (action.type) {
    case GUARDAR_CONDUCTO_IS_LOADING:
      return {
        ...state,
        guardarConductoHasError: false,
        guardarConductoIsLoading: true,
      };
    case GUARDAR_CONDUCTO_HAS_ERRORED:
      return {
        ...state,
        guardarConductoHasError: true,
        guardarConductoIsLoading: false,
      };
    case SET_GUARDAR_CONDUCTO:
      return {
        ...state,
        guardarConductoHasError: false,
        guardarConductoIsLoading: false,
        datoConducto: action.payload
      };

    default:
      return state;
  }
};
const dataFormaPago = {
  guardarFormaPagoHasError: false,
  guuardarFormaPagoIsLoading: false,
  datoFormaPago: []
};
export const datosGuardarFormaPago = (state = dataFormaPago, action) => {
  switch (action.type) {
    case GUARDAR_FORMA_PAGO_IS_LOADING:
      return {
        ...state,
        guardarFormaPagoHasError: false,
        guuardarFormaPagoIsLoading: true,
      };
    case GUARDAR_FORMA_PAGO_HAS_ERRORED:
      return {
        ...state,
        guardarFormaPagoHasError: true,
        guuardarFormaPagoIsLoading: false,
      };
    case SET_GUARDAR_FORMA_PAGO:
      return {
        ...state,
        guardarFormaPagoHasError: false,
        guuardarFormaPagoIsLoading: false,
        datoFormaPago: action.payload
      };

    default:
      return state;
  }
};

//FIn Formas de pago adicionales -------------------------------------



//COTIZACION HOGAR ----------------------------------------
export const catalogosHogar = handleActions(
  {
    [listarProvinciasHogarloading]: (state) => ({ ...state, listarProvinciasHogarloading: true, listarProvinciasHogarError: false, }),
    [listarProvinciasHogarError]: (state) => ({ ...state, listarProvinciasHogarError: true, listarProvinciasHogarloading: false }),
    [setProvinciasHogar]: (state, action) => ({ ...state, setProvinciasHogar: action.payload, listarProvinciasHogarError: false, listarProvinciasHogarloading: false }),

    [listarRelatividadesHogarloading]: (state) => ({ ...state, listarRelatividadesHogarloading: true, listarRelatividadesHogarError: false, }),
    [listarRelatividadesHogarError]: (state) => ({ ...state, listarRelatividadesHogarError: true, listarRelatividadesHogarloading: false }),
    [setRelatividadesHogar]: (state, action) => ({ ...state, setRelatividadesHogar: action.payload, listarRelatividadesHogarError: false, listarRelatividadesHogarloading: false }),
  },
  {
    listarProvinciasHogarloading: false,
    listarProvinciasHogarError: false,
    setProvinciasHogar: [],
    setRelatividadesHogar,
    listarRelatividadesHogarError,
    listarRelatividadesHogarloading
  }
);

//FIN COTIZACION HOGAR ----------------------------------------


//FACTURACION ------

//Recuperar datos 
export const dataFacturacion = handleActions(
  {
    [recuperarDatosFacturacionIsLoading]: (state) => ({ ...state, recuperarDatosFacturacionIsLoading: true, recuperarDatosFacturacionhasError: false, }),
    [recuperarDatosFacturacionhasError]: (state) => ({ ...state, recuperarDatosFacturacionhasError: true, recuperarDatosFacturacionIsLoading: false }),
    [setRecuperarDatosFacturacion]: (state, action) => ({ ...state, datosFacturacion: action.payload, recuperarDatosFacturacionhasError: false, recuperarDatosFacturacionIsLoading: false }),
    [setLimitesChasis]: (state, action) => ({ ...state, limitesChasis: action.payload }),
    [setLimitesAmparo]: (state, action) => ({ ...state, limitesAmparo: action.payload }),
    [setLimitesAvaluo]: (state, action) => ({ ...state, limitesAvaluo: action.payload }),
    [setLimitesMotor]: (state, action) => ({ ...state, limitesMotor: action.payload }),
    [setDatosAdicionales]: (state, action) => ({ ...state, datosAdicionales: action.payload }),
    
  },
  {
    recuperarDatosFacturacionIsLoading: false,
    recuperarDatosFacturacionhasError: false,
    datosFacturacion: [],
    limitesChasis: [],
    limitesMotor: [],
    datosAdicionales: null
  }
);

// Parametros de control
export const dataParametros = handleActions(
  {
    [setLimitesChasis]: (state, action) => ({ ...state, limChasis: action.payload }),
    [setLimitesAmparo]: (state, action) => ({ ...state, limAmparo: action.payload }),
    [setLimitesAvaluo]: (state, action) => ({ ...state, limAvaluo: action.payload }),
    [setLimitesMotor]: (state, action) => ({ ...state, limMotor: action.payload }),
    [limitesError]: (state, action) => ({ ...state, limError: action.payload })
  },
  {
    limError: false,
    limChasis: [],
    limAvaluo: [],
    limTelefono: [],
    limMotor: [],
  }
);


//Guardar datos 
export const dataGuardarFacturacion = handleActions(
  {
    [guardarDatosFacturacionIsLoading]: (state) => ({ ...state, guardarDatosFacturacionIsLoading: true, guardarDatosFacturacionhasError: false, }),
    [guardarDatosFacturacionhasError]: (state) => ({ ...state, guardarDatosFacturacionhasError: true, guardarDatosFacturacionIsLoading: false }),
    [setDatosFacturacionC]: (state, action) => ({ ...state, respuestaFacturacion: action.payload, guardarDatosFacturacionhasError: false, guardarDatosFacturacionIsLoading: false }),
  },
  {
    guardarDatosFacturacionIsLoading: false,
    guardarDatosFacturacionhasError: false,
    respuestaFacturacion: []
  }
);
//FIN FACTURACION -----

export const dataTerritoriosComparador = handleActions(
  {
    [setDataTerritoriosComparador]: (state, action) => ({ ...state, territorios: action.payload }),
  },
  { territorios: [] }


)



